export default {
  state: {
    statusCode: undefined,
    gcpUrl: null,
    gcpUrlFailed: false,
    gdsTrendsOverTimeUrl: null,
    gdsTrendsOverTimeUrlFailed: false,
    gdsWeeklyDetailUrl: null,
    gdsWeeklyDetailUrlFailed: false,
    brands: [],
    brand: null,
  },
  getters: {
    brands(state) {
      return state.brands.map(brand => {return {id: brand, title: brand.name}})
    },
  },
  mutations: {
    setStatusCode (state, statusCode) {
      state.statusCode = statusCode;
    },
    setGcpUrl (state, gcpUrl) {
      state.gcpUrl = gcpUrl;
    },
    setGcpUrlFailed (state, gcpUrlFailed) {
      state.gcpUrlFailed = gcpUrlFailed;
    },
    setGDSTrendsOverTimeUrl (state, val) {
      state.gdsTrendsOverTimeUrl = val;
    },
    setGDSTrendsOverTimeUrlFailed (state, val) {
      state.gdsTrendsOverTimeUrlFailed = val;
    },
    setGDSWeeklyDetailUrl (state, val) {
      state.gdsWeeklyDetailUrl = val;
    },
    setGDSWeeklyDetailUrlFailed (state, val) {
      state.gdsWeeklyDetailUrlFailed = val;
    },
    setBrands (state, brands) {
      state.brands = brands;
    },
    setBrand (state, brand) {
      state.brand = brand;
    },
  },
  actions: {
    async getDailyCounts (context, {brand}) {
      context.commit('setStatusCode', undefined);

      const query = brand ?`?brand=${brand.package_id || brand.application}` : '';
      await context.rootState.inst.get(
        `/api/dailyreports/${query}`,
      ).then((response) => {
        if (response.data.gcp_url) {
          context.commit('setGcpUrl', response.data.gcp_url);
        } else {
          context.commit('setGcpUrlFailed', true);
        }

        if (response.data.overtime_gds_url) {
          context.commit('setGDSTrendsOverTimeUrl', response.data.overtime_gds_url);
        } else {
          context.commit('setGDSTrendsOverTimeUrlFailed', true);
        }

        if (response.data.snapshot_gds_url) {
          context.commit('setGDSWeeklyDetailUrl', response.data.snapshot_gds_url);
        } else {
          context.commit('setGDSWeeklyDetailUrlFailed', true);
        }

        context.commit('setBrands', response.data.brands);
        context.commit('setBrand', response.data.brand);
        context.commit('setStatusCode', response.status);

        context.dispatch('getProfileDefinitionsData');
        context.dispatch('getPoiSetsData');
        context.dispatch('getProfileActionResponses', { clearData: true });
        context.dispatch('getAcornCodes');
      }).catch((error) => {
        context.commit('setStatusCode', error.response.status);
      });
    },
  }
}